if (!customElements.get('minions-banner')) {
  class MinionsBanner extends HTMLElement {
    connectedCallback() {
      this.targets = {
        days: this.querySelector('[data-count-value="days"]'),
        hours: this.querySelector('[data-count-value="hours"]'),
        minutes: this.querySelector('[data-count-value="minutes"]'),
        seconds: this.querySelector('[data-count-value="seconds"]')
      };

      this.targetDate = this.parseTargetDate(this.dataset.targetDate);
      const hasCountdown = !!this.targets.days;
      if (hasCountdown && this.targetDate) {
        this.render();
        const countdownEl = this.querySelector('.minions-banner__countdown');
        if (countdownEl && !countdownEl.hidden) {
          this.intervalId = window.setInterval(() => this.render(), 1000);
        }
      }
      this.bindScrollToProducts();
    }

    bindScrollToProducts() {
      this._onScrollToProductsClick = (event) => {
        const trigger = event.target.closest('[data-minions-banner-scroll-products]');
        if (!trigger) return;
        event.preventDefault();
        const productsLayout = document.querySelector('#shopify-section-template--21921440170201__minions_products_xKM9Df');
        if (!productsLayout) return;
        productsLayout.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      this.addEventListener('click', this._onScrollToProductsClick);
    }

    disconnectedCallback() {
      if (this._onScrollToProductsClick) {
        this.removeEventListener('click', this._onScrollToProductsClick);
      }
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
      }
    }

    parseTargetDate(rawValue) {
      if (!rawValue) return null;
      const parsedDate = new Date(rawValue);
      if (Number.isNaN(parsedDate.getTime())) return null;
      return parsedDate;
    }

    render() {
      if (!this.targetDate) return;
      const countdownEl = this.querySelector('.minions-banner__countdown');
      if (!countdownEl || countdownEl.hidden) return;

      const now = new Date();
      const totalSeconds = Math.max(0, Math.floor((this.targetDate.getTime() - now.getTime()) / 1000));

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.updateValue('days', days);
      this.updateValue('hours', hours);
      this.updateValue('minutes', minutes);
      this.updateValue('seconds', seconds);

      if (totalSeconds === 0) {
        countdownEl.hidden = true;
        if (this.intervalId) {
          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    }

    updateValue(name, value) {
      const target = this.targets[name];
      if (!target) return;
      target.textContent = this.padValue(value);
    }

    padValue(value) {
      return String(value).padStart(2, '0');
    }
  }

  customElements.define('minions-banner', MinionsBanner);
}
